import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import { API } from "../../services/api";
import { getUserDetails } from "../../services/apiProfile";

import "../../assets/css/style_new.css";
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import ProfileBio from "./ProfileBio";
import ProfileCommunity from "./ProfileCommunity";
import Spinner from "../../commonComponents/Spinner";
import chat from "../../assets/img/chat.svg"



const IndividualProfile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state || {};
    const [age, setAge] = useState('');
    const [userArr, setUserArr] = useState([]);
    const [postArr, setPostArr] = useState([]);
    const [isBio, setIsBio] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isCommunity, setIsCommunity] = useState(false);
    const[isRequestStatus,setRequestStatus]=useState('');
    const [activeTab, setActiveTab] = useState(localStorage.getItem('profileTab') ? localStorage.getItem('profileTab') : "MyPosts");
    const handleBioClose = () => setIsBio(false);
    const handleCommunityClose = () => setIsCommunity(false);
   
    const maxChars = 60;
    const profileToTabEventKey = {
        1: 'MyPosts',
        2: 'UpcomingEvents',
        3: 'Saved',
        4: 'Favorites',
    };
    const user = JSON.parse(localStorage.getItem('userData'));
    localStorage.setItem("receiverId", data.userId);


    
    useEffect(() => {

        if (user) {
            fetchUserDetails();
        }
    }, [location.state])


    const fetchUserDetails = async () => {
        setLoader(true)
        const formData = {
            userid: data.userId,
            loginuserid:user._id,
            offset: 0,
            limit: 10
        }
        let listProfile = await getUserDetails(formData);
        setUserArr(listProfile);
        setPostArr(listProfile.posts);
        setRequestStatus(listProfile.isChatUser.requestStatus);
        localStorage.setItem("isChatUserStatus", listProfile.isChatUser.requestStatus);
        localStorage.setItem("isBlockedChatUser", listProfile.isChatUser.isBlocked);
      
        setLoader(false);

        if (listProfile.user?.dob) {
            ageCalculator(listProfile.user?.dob)
        }

    };

    
    const ageCalculator = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            calculatedAge--;
        }

        setAge(calculatedAge)
        return calculatedAge
    }
    const sendmessage=async() => {
        navigate('/message');
       
   }
  
    return (

        <div >
            {loader && <Spinner />}
            <div className="main">
                <div className="contents">
                    <div className="profile_user">
                        <div className="coverimage">
                            <img src={
                                userArr?.user?.coverImage?.url && !userArr?.user?.profileSettings?.isPrivateProfile && userArr?.user?.profileSettings?.showCoverImage 
                                    ? API.uploadFilePath + userArr?.user?.coverImage?.url
                                    : profileimg
                            } alt="test" className="cover_profile" />
                            <div className="overlay"></div>
                        </div>
                        <div className="profile_main d-flex align-items-start">
                            <div className="profile_avatar pr-img-with-button">
                                <img src={
                                    userArr?.user?.profileImage?.url && !userArr?.user?.profileSettings?.isPrivateProfile && userArr?.user?.profileSettings?.showprofileImage 
                                        ? API.uploadFilePath + userArr?.user?.profileImage?.url
                                        : profileimg
                                } alt="test" className="cover_profile" />
                               
                                  {(isRequestStatus !== 3) && (
  <button className="start-msg" onClick={sendmessage}>Message</button>
)}
                               
                              
                            </div>
                            <div className="profile_details flex-fill">
                                <div className="avatarname_full d-flex-c">
                                    <h3>{userArr?.user?.firstName + " " + userArr?.user?.lastName}</h3>
                                </div>
                                <div className="avatar_other-details d-flex-c align-items-stretch">

                                    <div className="details_itms">
                                        <h4>Bio</h4>
                                        {/* {(!userArr?.user?.profileSettings?.isPrivateProfile || userArr?.user?.profileSettings?.showBio) && <p>{userArr.user?.bio?.slice(0, maxChars)}
                                            {userArr.user?.bio?.length > maxChars && <Link className="profile_edit" onClick={() => setIsBio(true)} >View more</Link>}
                                        </p>} */}
                                        {userArr?.user?.bio &&
                                            (!userArr.user?.profileSettings?.isPrivateProfile && userArr.user?.profileSettings?.showBio) && (
                                                <p>
                                                    {userArr.user.bio.slice(0, maxChars)}
                                                    {userArr.user.bio.length > maxChars && (
                                                        <Link className="profile_edit" onClick={() => setIsBio(true)}>View more</Link>
                                                    )}
                                                </p>
                                            )}

                                    </div>

                                    <div className="details_itms">
                                        <h4>About me</h4>
                                        <ul>
                                            <li>
                                                <b>Age</b><span>{(!userArr?.user?.profileSettings?.isPrivateProfile && userArr.user?.profileSettings?.showDob) &&age}</span>
                                            </li>
                                            {userArr?.user?.location !== "" && <li>
                                                <b>Location</b><span> {(!userArr?.user?.profileSettings?.isPrivateProfile && userArr.user?.profileSettings?.showLocation) && userArr?.user?.location}</span>
                                            </li>}
                                            {userArr?.user?.gender !== "" &&
                                                <li>
                                                    <b>Gender</b><span>{(!userArr?.user?.profileSettings?.isPrivateProfile && userArr.user?.profileSettings?.showGender) && userArr?.user?.gender}</span>
                                                </li>}
                                        </ul>
                                    </div>

                                    <div className="details_itms communities">
                                        <h4>Communities</h4>
                                        {!userArr?.user?.profileSettings?.isPrivateProfile && <ul className="profile_community d-flex flex-wrap" >
                                            {userArr?.communities?.length > 4 ?
                                                userArr.communities.slice(0, 3).map((community, index) => (
                                                    <li key={community._id}>
                                                        <img src={
                                                            community?.communityId?.profileImage?.url
                                                                ? API.uploadFilePath + community.communityId.profileImage.url
                                                                : profileimg
                                                        } alt="test" className="community_thumb" />
                                                        <span>{community.communityId.communityName} </span>
                                                    </li>)) :
                                                userArr?.communities?.length === 1 ?
                                                    userArr?.communities?.map((community, index) => (
                                                        <li key={community._id} className="full-width">
                                                            <img src={
                                                                community?.communityId?.profileImage?.url
                                                                    ? API.uploadFilePath + community.communityId.profileImage.url
                                                                    : profileimg
                                                            } alt="test" className="community_thumb" />
                                                            <span>{community.communityId.communityName}</span>
                                                        </li>)) :
                                                    userArr?.communities?.map((community, index) => (
                                                        <li key={community._id}>
                                                            <img src={
                                                                community?.communityId?.profileImage?.url
                                                                    ? API.uploadFilePath + community.communityId.profileImage.url
                                                                    : profileimg
                                                            } alt="test" className="community_thumb" />
                                                            <span>{community.communityId.communityName}</span>
                                                        </li>))}

                                            {userArr?.communities?.length > 4 &&
                                                <li>
                                                    <Link href="#" className="viewall" onClick={() => setIsCommunity(true)}>
                                                        <img src={eye} alt="test" className="community_thumb" />
                                                        <span>View all </span>
                                                    </Link>
                                                </li>}
                                        </ul>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* <ProfileQuestion type="profile" /> */}

            </div>
            {isBio ? <ProfileBio isBio={isBio} handleClose={handleBioClose} name={userArr?.user?.userType === "individual" ? userArr?.user?.firstName + " " + userArr?.user?.lastName : userArr?.user?.firstName} content={userArr?.user?.bio} /> : null}
            {isCommunity ? <ProfileCommunity isCommunity={isCommunity} handleClose={handleCommunityClose} community={userArr?.communities} /> : null}
        </div>
    );

};
export default IndividualProfile;
